import React, { useEffect, useState } from 'react';
import DepartmentScreen from './DepartmentScreen';
import BnCartonCheck from '../keyaccounts/BnCartonCheck';

// Carting station. The B&N carton check tab lives here too so the packing
// table can verify key-account cartons by scan. Only one tab is mounted at a
// time: DepartmentScreen listens for scanner keystrokes on the whole window.
// The floor tablet stays on this page for days, so it picks up new releases by
// itself: every 2 minutes it compares the live index.html's main bundle with
// the one it is running and reloads once nobody has scanned or typed for 2
// minutes (a reload clears a half-checked B&N carton).
const MAIN_JS = /static\/js\/main\.[0-9a-f]+\.js/;
function useReloadOnNewRelease() {
  useEffect(() => {
    const mine = [...document.scripts].map((x) => x.src).find((src) => MAIN_JS.test(src));
    if (!mine) return undefined; // dev server
    const current = mine.match(MAIN_JS)[0];
    let lastInput = Date.now();
    const touch = () => { lastInput = Date.now(); };
    window.addEventListener('keydown', touch, true);
    window.addEventListener('pointerdown', touch, true);
    const t = setInterval(async () => {
      try {
        const html = await (await fetch(`/index.html?v=${Date.now()}`, { cache: 'no-store' })).text();
        const live = (html.match(MAIN_JS) || [])[0];
        if (live && live !== current && Date.now() - lastInput > 120000) window.location.reload();
      } catch { /* offline; try again next round */ }
    }, 120000);
    return () => {
      clearInterval(t);
      window.removeEventListener('keydown', touch, true);
      window.removeEventListener('pointerdown', touch, true);
    };
  }, []);
}

function CartingScreen() {
  useReloadOnNewRelease();
  const [tab, setTab] = useState(() => {
    try { return localStorage.getItem('cartingTab') || 'carting'; } catch { return 'carting'; }
  });
  const pick = (t) => {
    setTab(t);
    try { localStorage.setItem('cartingTab', t); } catch { /* storage blocked */ }
  };
  const tabStyle = (on) => ({
    padding: '10px 18px', fontSize: 16, fontWeight: 600, borderRadius: 8, cursor: 'pointer',
    border: `1px solid ${on ? '#8B6F4E' : '#e5e0d8'}`, background: on ? '#8B6F4E' : '#fff', color: on ? '#fff' : '#3d3630',
  });

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, padding: '10px 16px', background: '#FAFAF8', borderBottom: '1px solid #e5e0d8' }}>
        <button type="button" style={tabStyle(tab === 'carting')} onClick={() => pick('carting')}>Carting</button>
        <button type="button" style={tabStyle(tab === 'bn')} onClick={() => pick('bn')}>B&amp;N carton check</button>
      </div>
      {tab === 'bn' ? (
        <BnCartonCheck />
      ) : (
        <DepartmentScreen
          department="carting"
          departmentName="Carting"
          nextDepartment="Wicking"
          color="#4CAF50"
        />
      )}
    </div>
  );
}

export default CartingScreen;
